import styled from "styled-components";

export const AuthContainer = styled.div`
  margin-top: 24px;
  text-align: center;
  padding: 16px;
  min-height: 35vh;
`